import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Ripple } from 'primereact/ripple';
import { classNames } from 'primereact/utils';
import { useEffect, useContext } from 'react';
import { CSSTransition } from 'react-transition-group';
import { MenuContext } from './context/menucontext';
import { useLocation } from 'react-router-dom';
const AppMenuitem = (props) => {
    const pathname = useLocation().pathname;
    const { activeMenu, setActiveMenu } = useContext(MenuContext);
    const item = props.item;
    const key = props.parentKey ? props.parentKey + '-' + props.index : String(props.index);
    const isActiveRoute = item.to && pathname === item.to;
    const active = activeMenu === key || activeMenu.startsWith(key + '-');
    const onRouteChange = (url) => {
        if (item.to && item.to === url) {
            setActiveMenu(key);
        }
    };
    useEffect(() => {
        onRouteChange(pathname);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);
    const itemClick = (event) => {
        //avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return;
        }
        //execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }
        // toggle active state
        if (item.items)
            setActiveMenu(active ? props.parentKey : key);
        else
            setActiveMenu(key);
    };
    const subMenu = item.items && item.visible !== false && (_jsx(CSSTransition, { timeout: { enter: 1000, exit: 450 }, classNames: "layout-submenu", in: props.root ? true : active, children: _jsx("ul", { children: item.items.map((child, i) => {
                return _jsx(AppMenuitem, { item: child, index: i, className: child.badgeClass, parentKey: key }, child.label);
            }) }) }, item.label));
    return (_jsxs("li", { className: classNames({ 'layout-root-menuitem': props.root, 'active-menuitem': active }), children: [props.root && item.visible !== false && _jsx("div", { className: "layout-menuitem-root-text", children: item.label }), (!item.to || item.items) && item.visible !== false ? (_jsxs("a", { href: item.url, onClick: (e) => itemClick(e), className: classNames(item.class, 'p-ripple'), target: item.target, tabIndex: 0, children: [_jsx("i", { className: classNames('layout-menuitem-icon', item.icon) }), _jsx("span", { className: "layout-menuitem-text", children: item.label }), item.items && _jsx("i", { className: "pi pi-fw pi-angle-down layout-submenu-toggler" }), _jsx(Ripple, {})] })) : null, item.to && !item.items && item.visible !== false ? (_jsxs(Link, { to: item.to, replace: item.replaceUrl, target: item.target, onClick: (e) => itemClick(e), className: classNames(item.class, 'p-ripple', { 'active-route': isActiveRoute }), tabIndex: 0, children: [_jsx("i", { className: classNames('layout-menuitem-icon', item.icon) }), _jsx("span", { className: "layout-menuitem-text", children: item.label }), item.items && _jsx("i", { className: "pi pi-fw pi-angle-down layout-submenu-toggler" }), _jsx(Ripple, {})] })) : null, subMenu] }));
};
export default AppMenuitem;
